// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
import keyMirror from 'mattermost-redux/utils/key_mirror';

export default keyMirror({

    RECEIVED_INCOMING_HOOK: null,
    RECEIVED_INCOMING_HOOKS: null,
    DELETED_INCOMING_HOOK: null,
    RECEIVED_OUTGOING_HOOK: null,
    RECEIVED_OUTGOING_HOOKS: null,
    DELETED_OUTGOING_HOOK: null,
    RECEIVED_CUSTOM_TEAM_COMMANDS: null,
    RECEIVED_COMMAND: null,
    RECEIVED_COMMANDS: null,
    RECEIVED_COMMAND_TOKEN: null,
    DELETED_COMMAND: null,
    RECEIVED_OAUTH_APP: null,
    RECEIVED_OAUTH_APPS: null,
    DELETED_OAUTH_APP: null,
    RECEIVED_APPS_OAUTH_APP_IDS: null,
    RECEIVED_APPS_BOT_IDS: null,

    RECEIVED_DIALOG_TRIGGER_ID: null,
    RECEIVED_DIALOG_CHANNEL_ID: null,
    RECEIVED_DIALOG: null,
});
